import { type ProductData } from "~/domains/product/types/ProductData";
import { DownloadUrlLink, getDownloadProperty } from "~/common/components/Link";
import { trackPDPDownloadDatasheet } from "~/app/analytics/ga/ga";
import { useUnitMode } from "~/domains/userPreferences/hooks/useUnitMode";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import type { UnitMode } from "~/domains/userPreferences/types/UnitMode";

interface PdfDownloadLinkProps {
  product: Pick<ProductData, "code" | "designation">;
  children?: ReactNode;
}

export const generatePdfDownloadUrl = (product: Pick<ProductData, "code" | "designation">, unitMode: UnitMode) => {
  let timezone;
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timezone = "UTC";
  }
  const url = `/p/pdf/${product.code}`;

  const params = new URLSearchParams();
  params.append("timezone", timezone);
  params.append("unit", unitMode);

  const pdfURL = url + "?" + params.toString();

  return pdfURL;
};

const PdfDownloadLink = ({ product }: PdfDownloadLinkProps) => {
  const { t } = useTranslation();

  const unitMode = useUnitMode();
  const url = generatePdfDownloadUrl(product, unitMode);

  const label = t("productDetailPage.downloadPdf");

  return (
    <DownloadUrlLink
      download={getDownloadProperty(`${product.designation}.pdf`)}
      href={url}
      className={"scha__pdp__pdf-link"}
      onClick={trackPDPDownloadDatasheet}
    >
      {label}
    </DownloadUrlLink>
  );
};

export default PdfDownloadLink;
